import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { Location } from '@angular/common';
import { Observable } from 'rxjs';
import { FormsModule, NgForm, AbstractControl } from '@angular/forms';
import { BaseBusyableComponent } from './BaseBusyableComponent';

declare var tinyMCEConfig: any;

export abstract class BaseEditComponent extends BaseBusyableComponent {

	constructor() {
		super();
		this.editorConfig = tinyMCEConfig;
	}

	public editorConfig: any = {};
	validationErrors: string[] = [];

	myRouter: Router = null;
	myLocation: Location = null;
	showValidationErrors(error: any, form: NgForm) {
		var errors = this.getErrorsFromResponse(error);
		if (error.error) {
			error = error.error;
		}
		if (error.ModelState) {
			var modelState = error.ModelState;
			for (var key in modelState) {
				if (modelState.hasOwnProperty(key)) {
					var fieldName = key.substring(key.indexOf("."));
					if (form) {
						for (var itemControlName in form.controls) {
							if (itemControlName.endsWith(fieldName)) {
								var elem = form.controls[itemControlName];
								this.setLiveCSS(elem, itemControlName);
							}
						}
					}
				}
			}
		};
		this.validationErrors = errors;
		this.isSaving = false;
	}

	cancel(form: NgForm) {
		this.isSaving = false;
		this.validationErrors = [];
		this.goBack();
	}

	goBack() {
		if (this.myLocation) {
			this.myLocation.back();
		}
	}
	setLiveCSS(elem: AbstractControl, property: string) {
		elem.setErrors({ property: true });
		//var ctrl = $(property);
		//var setValidity = function () {
		//	elem.setErrors({ property: false });
		//	ctrl.off('blur', setValidity);
		//}

		//// check validity on field blur
		//var blurVariable = ctrl.on('blur', setValidity);

		//// set "valid" by default on typing
		//var keyupVariable = ctrl.bind('keyup', setValidity);
	}
}


